<script setup lang="ts">
import SummaryTableBlockedData from '~/components/price-assessments/SummaryTableBlockedData.vue'
import { numberFormatter } from '~/utils/number'
import type { TRecord } from '~/src/types/common'

const props = defineProps<{
  authorized: boolean
  type: string
  item: {
    data: number
    unitMeasure: string
    currency: string
    isPublic: boolean
  }
  initialFields: TRecord[] | string[]
}>()

const transformedData = computed(() => {
  const data = props.item.data === null ? 0 : props.item.data
  return numberFormatter(data, 2)
})

const formatValue = computed(() => {
  return props.item.unitMeasure === '%'
    ? `${transformedData.value}%`
    : `${props.item.currency}${transformedData.value}`
})
const hasAccess = computed(() => props.item.isPublic || props.authorized)
</script>

<template>
  <div class="flex justify-center items-center text-sm">
    <template v-if="item.data !== null">
      <div v-if="type === 'price'">
        {{ formatValue }}
      </div>
      <PriceAssessmentsSummaryIndexValueNewPortal v-else :value="item.data" />
    </template>
    <div v-else-if="hasAccess" class="summary-table-row-item-value"> -- </div>
    <SummaryTableBlockedData v-else :initial-fields="initialFields" />
  </div>
</template>
